import { useSelector } from "react-redux";
import { CardChart, DonutCharts } from "../../components/dashboards";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { useState } from "react";
import { formatDateTime } from "../../lib/utils";
import { orderBy, filterBy } from "@progress/kendo-data-query";

import { useTranslation } from "react-i18next";

export const AlertNotificationDashboard = (props) => {
  const currentTheme = useSelector((state) => state.currentTheme);
  const pageState = useSelector((state) => state.notificationsPage);
  const [page, setPage] = useState({ skip: 0, take: 10 }); // Initial page state
  const [sort, setSort] = useState([]);
  const [filter, setFilter] = useState(null);

  const { t } = useTranslation();

  const handleFilterChange = (event) => {
    setFilter(event.filter);
  };
  const handlePageChange = (event) => {
    setPage({ skip: event.page.skip, take: event.page.take });
  };

  const handleSortChange = (e) => {
    setSort(e.sort);
  };

  const alertData = (pageState.groupedByTypeItems || []).filter(
    (item) => item.Type === 1
  );
  const messageData = (pageState.groupedByTypeItems || []).filter(
    (item) => item.Type === 2
  );
  const fetchingData = (pageState.groupedByTypeItems || []).filter(
    (item) => item.Type === 3
  );
  const correctionData = (pageState.groupedByTypeItems || []).filter(
    (item) => item.Type === 4
  );

  const allNotifications = [
    {
      category: t("notifications.alerts"),
      value: alertData[0]?.TotalRowsCount ? alertData[0]?.TotalRowsCount : 0,
      color: currentTheme.error,
    },
    {
      category: t("notifications.messages"),
      value: messageData[0]?.TotalRowsCount
        ? messageData[0]?.TotalRowsCount
        : 0,
      color:  "#ccc",
    },
    {
      category: t("notifications.data"),
      value: fetchingData[0]?.TotalRowsCount
        ? fetchingData[0]?.TotalRowsCount
        : 0,
        color: currentTheme.touchColor,
    },
    {
      category: t("notifications.correction"),
      value: correctionData[0]?.TotalRowsCount
        ? correctionData[0]?.TotalRowsCount
        : 0,
      color: "#4caf50",
    },
  ];

  const criticalData = pageState.groupedByImportanceItems.filter(
    (item) => item.Importance === 5
  );
  const importantData = pageState.groupedByImportanceItems.filter(
    (item) => item.Importance === 3
  );
  const unimportantData = pageState.groupedByImportanceItems.filter(
    (item) => item.Importance === 1
  );

  const getReadSubtitle = (data) =>
    t("notifications.read_count", {
      read: data[0]?.TotalReadCount ?? 0,
      total: data[0]?.TotalRowsCount ?? 0,
    });

  const cards1 = [
    {
      title: t("notifications.critical"),
      subtitle: getReadSubtitle(criticalData),
    },
    {
      title: t("notifications.important"),
      subtitle: getReadSubtitle(importantData),
    },
    {
      title: t("notifications.unimportant"),
      subtitle: getReadSubtitle(unimportantData),
    },
  ];

  const getTypeText = (type) => {
    switch (type) {
      case 1:
        return t("notifications.alert");
      case 2:
        return t("notifications.message");
      case 3:
        return t("notifications.data");
      case 4:
        return t("notifications.correction");
      default:
        return "";
    }
  };

  const getImportanceText = (importance) => {
    switch (importance) {
      case 35:
        return t("notifications.important_critical");
      case 5:
        return t("notifications.critical");
      case 3:
        return t("notifications.important");
      default:
        return t("notifications.unimportant");
    }
  };

  console.log("DonutChart Data:", allNotifications);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        margin: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "16px",
          justifyContent: "space-between",
        }}
      >
        {cards1.map(({ title, subtitle }, index) => (
          <CardChart
            key={index}
            title={title}
            subtitle={subtitle}
            style={{ flex: 1, textAlign: "center" }}
          />
        ))}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center", // Ensures vertical alignment
          justifyContent: "space-between", // Ensures proper spacing
          gap: "16px", // Adds spacing between elements
          flexWrap: "wrap", // Prevents layout breaking on smaller screens
          margin: "20px 40px",
        }}
      >
        {/* Donut Chart */}
        <DonutCharts
          title={t("notifications.allnot")}
          type="pie"
          data={allNotifications}
          currentTheme={currentTheme}
          legendPosition="bottom"
          labelContent={(e) => e.value }
          widthChart="350px"
        />

        <div
          style={{
            flex: 1, // Takes available space
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
            gap: "10px",
          }}
        >
          {[
            {
              label: t("notifications.alerts"),
              value: `${alertData[0]?.TotalReadCount ?? 0}/${
                alertData[0]?.TotalReadCount ?? 0
              } read`,
            },
            {
              label: t("notifications.messages"),
              value: `${messageData[0]?.TotalReadCount ?? 0}/${
                messageData[0]?.TotalRowsCount ?? 0
              } read`,
            },
            {
              label: t("notifications.processed"),
              value: `${fetchingData[0]?.TotalReadCount ?? 0}/${
                fetchingData[0]?.TotalRowsCount ?? 0
              } read`,
            },
            {
              label: t("notifications.correction"),
              value: `${correctionData[0]?.TotalReadCount ?? 0}/${
                correctionData[0]?.TotalRowsCount ?? 0
              } read`,
            },
          ].map(({ label, value }) => (
            <div
              key={label}
              style={{
                // display: "flex",
                // alignItems: "center",
                // justifyContent: "space-between",
                textAlign: "center",
                padding: "8px 12px",
                border: `1px solid ${currentTheme.touchColor}`, // Consistent border
                borderRadius: "6px",
              }}
            >
              <span style={{ fontWeight: "bold", paddingRight: "8px" }}>
                {label}
              </span>

              <br />
              <span>{value}</span>
            </div>
          ))}
        </div>
      </div>
      <div style={{ margin: "20px 0" }}>
        <Grid
          data={filterBy(
            orderBy(
              pageState.items.slice(page.skip, page.skip + page.take),
              sort
            ),
            filter
          )}
          filterable
          filter={filter}
          onFilterChange={handleFilterChange} // Handle filter change
          sortable
          pageable={{ pageSizes: true, buttonCount: 5 }}
          total={pageState.items.length}
          skip={page.skip}
          take={page.take}
          onPageChange={handlePageChange}
          onSortChange={handleSortChange}
          sort={sort}
          style={{ height: "400px" }}
          rowHeight={50}
          resizable={true}
          onRowClick={(event) => props.onEntitySelected(event.dataItem.Id)}
        >
          <GridColumn field="Id" title={t("notifications.id")} width="80" sortable />
          <GridColumn field="Title" title={t("notifications.title")} width="auto" sortable />
          <GridColumn
            field="Type"
            title={t("notifications.type")}
            cell={(props) => <td>{getTypeText(props.dataItem.Type)}</td>}
          />
          <GridColumn
            field="Importance"
            title={t("notifications.importance1")}
            cell={(props) => (
              <td>{getImportanceText(props.dataItem.Importance)}</td>
            )}
          />
          <GridColumn
            field="Status"
            title={t("notifications.status")}
            width="auto"
            sortable
            cell={(props) => {
              const statusText =
                props.dataItem.Status === -1 ? t("notifications.notread") : t("notifications.read1");
              return <td>{statusText}</td>;
            }}
          />
          {/* New Date Column */}
          <GridColumn
            field="InitiatedOn"
            title={t("notifications.initiatedon")}
            width="auto"
            sortable
            cell={(props) => {
              return <td>{formatDateTime(props.dataItem.InitiatedOn)}</td>;
            }}
          />
        </Grid>
      </div>
      <style>
        {`
          .notifications-page .k-card .k-card-title{
              font-size:16px;
              font-weight:bold;
              color:${currentTheme.touchColor}
          }
          .notifications-page .k-card .k-card-subtitle{
              font-size:14px;
              color:${currentTheme.primary}
          }
        `}
      </style>
    </div>
  );
};
